import { codeListGet } from "../api";
import { jsError } from "./utils";

let fetched = false;
const settings = {};

// remember top menu path for each section, so that user is returned to the same subpage when clicking the top menu again
export const topPath = {};

const dimensionMapper = arr => arr.reduce((map, item) => {
  map[item.codeKey] = item.codeValue;
  return map;
}, {});

export function initSettings() {
  fetched = false;
  Object.keys(settings).forEach(key => delete settings[key]);
  Object.keys(topPath).forEach(key => delete topPath[key]);
}

// export Promise of common data fetched only once
export async function fetchSettings() {
  if (fetched) {
    return settings;
  }

  try {
    let res;

    settings.dim1key = "costUnits";
    res = await codeListGet(settings.dim1key);
    settings.dim1name = res.data.name;
    settings.dim1map = dimensionMapper(res.data.items);

    settings.dim2key = "projects";
    res = await codeListGet(settings.dim2key);
    settings.dim2name = res.data.name;
    settings.dim2map = dimensionMapper(res.data.items);

    settings.dim3key = "dim3";
    res = await codeListGet(settings.dim3key);
    settings.dim3name = res.data.name;
    settings.dim3map = dimensionMapper(res.data.items);

    settings.dim4key = "dim4";
    res = await codeListGet(settings.dim4key);
    settings.dim4name = res.data.name;
    settings.dim4map = dimensionMapper(res.data.items);

    settings.dim5key = "dim5";
    res = await codeListGet(settings.dim5key);
    settings.dim5name = res.data.name;
    settings.dim5map = dimensionMapper(res.data.items);
    /*
    settings.dim6key = "dim6";
    res = await codeListGet(settings.dim6key);
    settings.dim6name = res.data.name;
    settings.dim6map = dimensionMapper(res.data.items);
    */
  }

  catch { // if no dimension codelists, import them from eSalary
    jsError("Error getting dimensions");
  }

  fetched = true;
  return settings;
}
